import { h, FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { isMultipleOfferFlowSelector } from '~src/domains/common/state/commonSelectors';
import { LoanOfferType } from '~src/domains/common/types/offers';
import OfferSelector from './OfferSelector';
import * as styles from '~src/styles/domains/accept/components/OfferSelector.module.scss';

type OfferSelectorsProps = {
  offers: LoanOfferType[];
  hideAPR?: boolean;
};

const OfferSelectors: FunctionComponent<OfferSelectorsProps> = ({
  offers,
  hideAPR,
}) => {
  const isMultipleOfferFlow = useSelector(isMultipleOfferFlowSelector);

  const indexOfHighest = offers.reduce(
    (maxIndex, currentOffer, currentIndex, array) => {
      if (
        currentOffer.number_of_payments > array[maxIndex].number_of_payments
      ) {
        return currentIndex;
      }
      return maxIndex;
    },
    0,
  );

  return (
    <div className={styles['payment-plan-container']}>
      {offers.map((offer, index) => (
        <OfferSelector
          index={index}
          offer={offer}
          hideAPR={hideAPR}
          isMultipleOfferFlow={isMultipleOfferFlow}
          isLowest={index === indexOfHighest}
        />
      ))}
    </div>
  );
};

export default OfferSelectors;
